module.exports = __webpack_public_path__ + "img/Bolivia.ca8177e8.gif";